<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->

    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">LICENSE INFO</h2>
                </div>

                <div class="form">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Type</label><span style="color: red;">*</span><br />
                            <select class="txt-input " [(ngModel)]="LicType"
                                style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                <option value="0" disabled>Select</option>
                                <option value="AAS">AAS
                                </option>
                                <option value="MEIS">MEIS
                                </option>
                            </select>
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Name</label><span style="color: red;">*</span><br />
                            <input type="text" id="NotifyNum" [(ngModel)]="LicenseName" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Number</label><span style="color: red;">*</span><br />
                            <input type="text" id="NotifyNum" [(ngModel)]="LicenseNumber" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>License Date</label><span style="color: red;">*</span><br />
                            <input type="date" id="NotifyNum" [(ngModel)]="LicenseDate" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Valid From</label><span style="color: red;">*</span><br />
                            <input type="date" id="NotifyNum" [(ngModel)]="ValidFrom" class="txt-input" />
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Valid To</label><span style="color: red;">*</span><br />
                            <input type="date" id="NotifyNum" [(ngModel)]="ValidTo" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Currency</label><span style="color: red;">*</span><br />
                            <input type="text" id="Currency" [(ngModel)]="LicCurrency" class="txt-input"
                                list="currencyId" />
                            <datalist id="currencyId">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cur of AdmCurrency" value={{cur.currencyCode}}>{{cur.currencyCode}}
                                </option>
                            </datalist>

                            <!-- <select class="form-control" [(ngModel)]="LicCurrency"
                                style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                <option value="0" disabled>Select</option>
                                <option value="">
                                </option>
                            </select> -->
                        </div>
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Value (INR)</label><span style="color: red;">*</span><br />
                            <input type="number" id="NotifyNum" [(ngModel)]="LicValue" class="txt-input"  />
                        </div>

                    </div>
                    <!-- <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-3" style="text-align: left;">
                            <label>Upload Attachment</label><span style="color: red;">*</span><br />
                            <div class="clearfix">
                                <div class="upload-btn-wrapper">
                                    <button class="btnUpload">Upload &nbsp; <img src="../../assets/UploadIcon.png">
                                    </button>
                                    <input type="file" #file (change)="uploadFile(file.files)" id="myfile" />
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-lg-6 grid-margin">
                            <label>Document Upload</label><br />
                            <div class="col-lg-6" style="border: ridge;padding-bottom: 2em;">
                                <div class="clearfix">
                                    <div class="upload-btn-wrapper" style="padding-left: 50px;">
                                        <button class="btnUpload">Upload&nbsp; <img src="../../assets/UploadIcon.png">
                                        </button>
                                        <input type="file" #file (change)="uploadFile(file.files)" id="myfile"
                                            multiple />
                                    </div>
                                </div>
                                <div [hidden]="isShowndoclist">
                                    <ol type="1" class="selects">
                                        <li *ngFor="let slt of selects">
                                            <span><a href="{{slt.fileURL}}" target="_blank">{{slt.filename}}</a></span>
                                        </li>
                                    </ol>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="row" style="width:100%;padding-left: 15px; ">
                        <div class="col-lg-10" style="border: ridge;padding-bottom: 2em;">
                            <div class="col-lg-12">
                                <div class="row" style="padding-top:1em;">
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Item Number</label><span style="color: red;">*</span><br />
                                        <input type="text" id="NotifyNum" [(ngModel)]="ItemNo" class="txt-input" />
                                    </div>
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Part Number</label><span style="color: red;">*</span><br />
                                        <select class="txt-input" [(ngModel)]="partsId"
                                            style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                            <option value="0" disabled>Select</option>
                                            <option *ngFor="let pts of Parts" value={{pts.partsId}}>{{pts.partNo}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Part Name</label><span style="color: red;">*</span><br />
                                        <input type="text" id="NotifyNum" [(ngModel)]="PartName" class="txt-input" />
                                    </div>
                                </div>
                                <div class="row" style="padding-top:1em;">
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Unit</label><span style="color: red;">*</span><br />
                                        <input type="text" id="NotifyNum" [(ngModel)]="ItemUnit" class="txt-input" />
                                    </div>
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Unit Weight</label><span style="color: red;">*</span><br />
                                        <input type="text" id="NotifyNum" [(ngModel)]="ItemUnitWeight"
                                            class="txt-input" />
                                    </div>
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Unit Price</label><span style="color: red;">*</span><br />
                                        <input type="number" id="NotifyNum" [(ngModel)]="ItemUnitPrice"
                                            class="txt-input"  />
                                    </div>
                                </div>
                                <div class="row" style="padding-top:1em;">
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Quantity</label><span style="color: red;">*</span><br />
                                        <input type="number" id="NotifyNum" [(ngModel)]="ItemQuantity"
                                            class="txt-input" />
                                    </div>
                                    <div class="col-lg-3" style="text-align: left;">
                                        <label>Value (INR)</label><span style="color: red;">*</span><br />
                                        <input type="number" id="NotifyNum" [(ngModel)]="ItemUnitValue"
                                            class="txt-input"  />
                                    </div>
                                    <div class="col-lg-5" style="text-align: left;" style="padding-top: 25px;">
                                        <button class="bttn-save " (click)="btnAddClick()"
                                            [hidden]="isShownadBtn">ADD</button>
                                        <button class="bttn-save " [hidden]="isShownupdBtn"
                                            (click)="btnUpdateClick()">Update</button>&nbsp;
                                        <button class="bttn-save " (click)="btnpartclear()">Clear</button>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                    <div class="row" style="padding-top: 10px;">
                        <div class="col-lg-12 grid-margin" style="margin-bottom: 0px !important;padding-left: 0px;">
                            <div class="card">
                                <div class="card-body" style="width:fit-content;">
                                    <div class="row">
                                        <div class="col-12 grid-margin">
                                            <div class="card">
                                                <div class="card-body" style="padding: 0;">
                                                    <div class="col-sm-12 mat-elevation-z8"
                                                        style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                        <table mat-table [dataSource]="dataSourceItem"
                                                            style="width: 100%;" style="width: 100%;" matSort
                                                            #TableItemSort="matSort">
                                                            <ng-container matColumnDef="sno">
                                                                <th mat-header-cell *matHeaderCellDef
                                                                    style="color: black !important;background-color: white">
                                                                    S.NO </th>
                                                                <td mat-cell *matCellDef="let item; let j = index">
                                                                    {{(j +1)  + (TableItemPaginator.pageIndex * TableItemPaginator.pageSize) }}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="itemnum">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Item Number</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.itemnum}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="partnumber">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Part Number</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.partnumber}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="partname">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Part Name</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.partname}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="unit">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Unit</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.unit}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="unitWeight">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Unit Weight</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.unitWeight}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="unitPrice">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Unit Price</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.unitPrice}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="quantity">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Quantity</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.quantity}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="value">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Value</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicense(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.value}}
                                                                </td>
                                                            </ng-container>
                                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsItem">
                                                            </tr>
                                                            <tr mat-row
                                                                *matRowDef="let row; columns: displayedColumnsItem;">
                                                            </tr>
                                                        </table>
                                                        <mat-paginator #TableItemPaginator="matPaginator"
                                                            [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                            showFirstLastButtons></mat-paginator>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 10px;">
                        <div class="col-lg-5">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" id="description" [(ngModel)]="Description"
                                class="txt-input"></textarea>
                        </div>
                        <div class="col-lg-2" style="padding-top:60px;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 50px;">
                            <button class="bttn-save " [hidden]="isShownSaveBtn"
                                (click)="SaveLicenseInfo()">SAVE</button>
                            &nbsp;&nbsp;
                            <button class="bttn-Update" [hidden]="isShownUpdateBtn"
                                (click)="UpdateLicenseInfo()">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear " (click)="ClearLicense()">CLEAR</button>
                        </div>
                    </div>

                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>

                </div>


                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin">
                            <div class="card">
                                <div class="card-body" style="width:fit-content;">
                                    <div class="row">
                                        <div class="col-12 grid-margin">
                                            <div class="card">
                                                <div class="card-body" style="padding: 0;">
                                                    <div class="col-lg-12 form-inline"
                                                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                        <div class="col-lg-5"></div>
                                                        <div class="col-lg-7">
                                                            <div class="form-group">
                                                                <div class="input-group">
                                                                    <input type="text" placeholder="Search"
                                                                        [(ngModel)]="searchText"
                                                                        (keyup)="applyFilter($event.target.value)"
                                                                        class="txt-Search"> <i
                                                                        class="fa fa-search fa-2x"
                                                                        style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>

                                                                </div>
                                                                <button type="button" class="btn btn-sm ">
                                                                    <img src="../../assets/ExportPDF.png" />
                                                                </button>
                                                                <button type="button" class="btn  btn-sm"
                                                                    (click)="exportexcel()">
                                                                    <img src="../../assets/ExportExcel.png"
                                                                        style="cursor: pointer;" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-sm-12 mat-elevation-z8"
                                                        style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                        <table mat-table [dataSource]="dataSource1" #table
                                                            style="width: 100%;" matSort #sort1="matSort">
                                                            <ng-container matColumnDef="sno">
                                                                <th mat-header-cell *matHeaderCellDef
                                                                    style="color: black !important;background-color: white">
                                                                    S.NO </th>
                                                                <td mat-cell *matCellDef="let item; let j = index">
                                                                    {{(j +1)  + (paginator1.pageIndex * paginator1.pageSize) }}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="type">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Type</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.type}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="number">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Number</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.number}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="licenseDate1">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    License Date</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.licenseDate1}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="validFrom1">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Valid From</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.validFrom1}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="validTo1">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    ValidTo</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.validTo1}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="currency">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Currency</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.currency}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="value">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Value</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.value}}
                                                                </td>
                                                            </ng-container>
                                                            <ng-container matColumnDef="status">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    style="color: black !important;background-color: white">
                                                                    Status</th>
                                                                <td mat-cell *matCellDef="let element"
                                                                    (click)="Editlicdet(element)"
                                                                    style="cursor: pointer;">
                                                                    {{element.status}}
                                                                </td>
                                                            </ng-container>
                                                            <tr mat-header-row *matHeaderRowDef="displayedColumns1">
                                                            </tr>
                                                            <tr mat-row
                                                                *matRowDef="let row; columns: displayedColumns1;">
                                                            </tr>
                                                        </table>
                                                        <mat-paginator #paginator1
                                                            [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                            showFirstLastButtons></mat-paginator>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4"></div>
                                        <div class="col-lg-4"></div>
                                        <div class="col-lg-4">

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- partial:../../partials/_footer.html -->
                <footer class="footer">
                    <div class="d-sm-flex justify-content-center">
                        <span class="d-block d-sm-inline-block">
                            © 2020 All Rights Reserved
                            <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                                <img src="../../assets/Logo-V3.png" width="70" />
                            </a>

                        </span>

                    </div>
                </footer>
                <!-- partial -->
            </div>
        </div>
    </div>